import React, {lazy, Suspense} from 'react'

const ProfilePageLazy = lazy(() =>
    import('./ProfilePage')
)

const ProfilePage = props => (
    <Suspense fallback={null}>
        <ProfilePageLazy {...props} />
    </Suspense>
)

export default ProfilePage
